module.exports = "/_next/static/images/circle_grey-a5fe048b1a9a3e290d95c2dccea725aa.png";